<template>
  <div class="sci-page-wrapper" style="font-family: 'Inter', sans-serif;">
    <div class="max-w-7xl mx-auto">
      <div v-if="loader" class="flex flex-col justify-center items-center py-12">
        <svg class="animate-spin h-10 w-10 text-emerald-600 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <span class="text-slate-500 font-medium">Carregando relatório...</span>
      </div>
      <div v-else-if="showMessage" class="bg-white rounded-xl shadow-sm border border-slate-200 p-12 flex flex-col items-center justify-center text-center">
        <v-icon color="orange" size="48" class="mb-4">mdi-alert-circle-outline</v-icon>
        <p class="font-bold text-slate-700 text-lg mb-2">Ops! Algo deu errado.</p>
        <p class="text-slate-500 max-w-md">{{ message }}</p>
        <button class="mt-6 bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold py-2 px-6 rounded-lg transition-colors" @click="loadReport">Tentar Novamente</button>
      </div>
      <AllReport
        v-else
        id="conferenceList"
        :data="dataReport"
        :filter="filter"
        :prefecture="prefecture"
        :provider="provider"
        ref="allComponent"
      />
    </div>
  </div>
</template>

<script>
import Helpers from "@/mixins/helpers.js";
import AllReport from "../impressions/conferencebillingsecretariart";
export default {
  components: { AllReport },
  mixins: [Helpers],
  props: {
    endDate: null,
    startDate: null,
    provider_id: null,
    prefecture_id: null,
    vehicle_id: null,
  },
  data: () => ({
    dataReport: [],
    filter: {},
    prefecture: [],
    provider: [],
    loader: false,
    showMessage: false,
    message: "",
  }),
  created() {
    this.loadReport();
    this.Helpers;
  },
  methods: {
    loadReport() {
      this.loader = true;
      this.showMessage = false;
      this.message = "";
      this.$store.dispatch("setLoader", this.loader);

      const sanitizeId = (id) => (id === "null" || id === "0" || !id) ? null : id;

      this.filter = {
        endDate: this.endDate,
        startDate: this.startDate,
        provider_id: sanitizeId(this.provider_id),
        prefecture_id: sanitizeId(this.prefecture_id),
        vehicle_id: sanitizeId(this.vehicle_id),
        sec_id: null,
      };

      this.$http.post(`/supplies/period/report/provider`, this.filter).then((r) => {
          this.$http
            .get(`/prefectures/${this.filter.prefecture_id}`)
            .then((p) => {
              this.prefecture = p.data[0];
              this.$http
                .get(`/providers/${this.filter.provider_id}`)
                .then((pp) => {
                  this.provider = pp.data[0];

                  if (r.data && r.data.supplies) {
                    r.data.supplies.sort((a, b) => {
                      const nameA = (a.sec_name || "").toUpperCase();
                      const nameB = (b.sec_name || "").toUpperCase();
                      return nameA.localeCompare(nameB);
                    });
                  }

                  this.dataReport = r.data;

                  let resume = [];
                  let totalFinalLiters = 0;
                  let totalFinalValuesBilling = 0;
                  // Totais por secretaria: { [sec_name]: { totalLiters, totalValue, items: [{item_id, item_description_desc, supply_bidding_price, totalLiters, totalValue}] } }
                  let resumeBySecretaria = {};

                  if (r.data && r.data.supplies) {
                    r.data.supplies.forEach((element) => {
                      totalFinalLiters += Number(element.totalLiters || 0);
                      totalFinalValuesBilling += Number(element.totalValue || 0);

                      // Resumo geral por item
                      const index = resume.findIndex(
                        (v) => v.item_id == element.item_id
                      );
                      if (index >= 0) {
                        resume[index].totalLiters += Number(element.totalLiters || 0);
                        resume[index].totalValue += Number(element.totalValue || 0);
                      } else {
                        resume.push({
                          item_id: element.item_id,
                          item_description_desc: element.item_description_desc,
                          supply_bidding_price: element.supply_bidding_price,
                          totalLiters: Number(element.totalLiters || 0),
                          totalValue: Number(element.totalValue || 0),
                        });
                      }

                      // Resumo por secretaria
                      const secName = element.sec_name || "SEM SECRETARIA";
                      if (!resumeBySecretaria[secName]) {
                        resumeBySecretaria[secName] = {
                          totalLiters: 0,
                          totalValue: 0,
                          items: [],
                        };
                      }
                      resumeBySecretaria[secName].totalLiters += Number(element.totalLiters || 0);
                      resumeBySecretaria[secName].totalValue += Number(element.totalValue || 0);

                      const secItemIndex = resumeBySecretaria[secName].items.findIndex(
                        (v) => v.item_id == element.item_id
                      );
                      if (secItemIndex >= 0) {
                        resumeBySecretaria[secName].items[secItemIndex].totalLiters += Number(element.totalLiters || 0);
                        resumeBySecretaria[secName].items[secItemIndex].totalValue += Number(element.totalValue || 0);
                      } else {
                        resumeBySecretaria[secName].items.push({
                          item_id: element.item_id,
                          item_description_desc: element.item_description_desc,
                          supply_bidding_price: element.supply_bidding_price,
                          totalLiters: Number(element.totalLiters || 0),
                          totalValue: Number(element.totalValue || 0),
                        });
                      }
                    });
                  }

                  if (!this.dataReport.finalTotals) {
                    this.dataReport.finalTotals = {};
                  }
                  this.dataReport.finalTotals.totalFinalLiters = totalFinalLiters;
                  this.dataReport.finalTotals.totalFinalValuesBilling = totalFinalValuesBilling;
                  this.dataReport.resume = resume;
                  this.dataReport.resumeBySecretaria = resumeBySecretaria;

                  setTimeout(() => {
                    this.loader = false;
                    this.$store.dispatch("setLoader", this.loader);
                  }, 1000);
                })
                .catch((e) => {
                  this.message = "Erro ao carregar dados do fornecedor: " + e.message;
                  this.showMessage = true;
                  this.loader = false;
                  this.$store.dispatch("setLoader", this.loader);
                });
            })
            .catch((e) => {
              this.message = "Erro ao carregar dados da prefeitura: " + e.message;
              this.showMessage = true;
              this.loader = false;
              this.$store.dispatch("setLoader", this.loader);
            });
        })
        .catch((e) => {
          this.message = "Erro ao buscar dados do relatório: " + (e.response?.data?.message || e.message);
          this.showMessage = true;
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
        });
    },
  },
};
</script>

<style>
</style>